module.exports = __webpack_public_path__ + "static/img/1.749123a3.jpg";